// Constants
export enum thousandSeparators {
  arabicComma = '٬',
  comma = ',',
  dot = '.',
  space = ' ',
  none = '',
}

//
export enum decimalSeparators {
  arabicPoint = '٫',
  comma = ',',
  dot = '.',
  underscore = '_',
  slash = '/',
}
